
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M8 .875a7.125 7.125 0 110 14.25A7.125 7.125 0 018 .875zm-.375 10.5H5.707c.39.793.916 1.587 1.581 2.385.02.024.037.05.05.077l.143.015.144.011v-2.488zm2.668 0H8.375v2.488c.097-.006.193-.014.288-.025a.316.316 0 01.049-.078c.665-.798 1.191-1.592 1.58-2.384zm-5.414 0l-1.688.001a5.888 5.888 0 003.011 2.219 11.775 11.775 0 01-1.323-2.22zm7.93 0H11.12a11.77 11.77 0 01-1.322 2.219 5.882 5.882 0 003.01-2.218zm-8.675-3H2.137a5.84 5.84 0 00.606 2.25H4.58a8.038 8.038 0 01-.447-2.25zm3.491 0h-2.74a7.4 7.4 0 00.494 2.25h2.246v-2.25zm3.49 0h-2.74v2.25h2.246a7.4 7.4 0 00.494-2.25zm2.748 0l-1.997.001a8.038 8.038 0 01-.447 2.25h1.838a5.84 5.84 0 00.606-2.25zM2.127 7.85L2.125 8l.003.151-.001-.3zM4.58 5.376H2.742a5.84 5.84 0 00-.605 2.25h1.997a8.037 8.037 0 01.446-2.25zm3.045-.001H5.379a7.4 7.4 0 00-.494 2.25h2.74v-2.25zm2.996 0H8.375v2.25h2.74a7.4 7.4 0 00-.494-2.25zm2.636 0H11.42c.26.749.409 1.499.446 2.25h1.997a5.84 5.84 0 00-.606-2.25zm-7.055-2.97l-.084.028A5.89 5.89 0 003.19 4.625h1.687a11.77 11.77 0 011.324-2.22zm1.423-.268a5.908 5.908 0 00-.288.025.315.315 0 01-.049.078c-.665.798-1.192 1.593-1.581 2.386l1.918-.001V2.137zm.75 0v2.488h1.918c-.389-.792-.916-1.587-1.581-2.385a.376.376 0 01-.05-.077 4.442 4.442 0 00-.286-.026zm1.423.268l.206.285c.456.643.828 1.289 1.118 1.936l1.687-.001a5.888 5.888 0 00-3.011-2.22z"}})])
          )
        }
      }
    